import { GET_BECAS_LIST} from "./BecasAction";

let initialState = {
    getBecasList:           false,
    errorBecasList:         false,
};

const BecasReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_BECAS_LIST:
            return {
                ...state,
                getBecasList: action.payload.data,
                errorBecasList: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default BecasReducer;